import FrankensteinSpinner from "@/components/FrankensteinSpinner";

export default function Frankenstein() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="frankenstein-page">
      <span className="text-xs uppercase tracking-[0.22em] font-extrabold text-[#920e12]">Dr. Frankenstein</span>
      <h1 className="mt-2 font-display text-4xl text-[#550001]">Build a character</h1>
      <p className="mt-2 text-[#545454]">Click Spin to build a wild character. Hit Projector for the full-screen version. Sensory-Friendly mode (top-right) removes the spinning wheel and ticking sound.</p>
      <div className="mt-6"><FrankensteinSpinner /></div>
    </div>
  );
}
